<template>
  <div class="auth-wrapper auth-v2">
    <b-row class="auth-inner m-0">
      <!-- Brand logo-->
      <b-link class="brand-logo" href="/intro">
        <!-- <b-img :src="appLogoImage" alt="logo" /> -->
        <b-img :src="appLogoImage" alt="logo" style="width: 100%; margin-left: -2px;"/>
        <!-- <h2 class="brand-text text-primary ml-1">{{ appName }}</h2>        -->
      </b-link>
      <!-- /Brand logo-->

      <!-- Left Text-->
      <b-col lg="8" class="d-none d-lg-flex align-items-center p-5">
        <div 
          class="w-100 d-lg-flex align-items-center justify-content-center px-5"
        >
          <b-img fluid src="@/assets/images/pages/login-v2.svg" alt="Login" />
        </div>
      </b-col>
      <!-- /Left Text-->

      <!-- Login-->
      <b-col lg="4" class="d-flex align-items-center auth-bg px-1 p-lg-6">
        <b-col sm="8" md="6" lg="12" class="px-xl-1 mx-auto">
          <div class="d-flex justify-content-end" style="margin-bottom: 50%; padding-bottom: 0px;">
            <b-button href="/intro" variant="secondary" size="sm" style="text-align: center; width: 20%; margin-right: 5px; margin-top: 1rem;">Home</b-button>
            <b-button @click="openAbout()" variant="secondary" size="sm" style="text-align: center; width: 20%; margin-right: 5px; margin-top: 1rem;">Introduction</b-button>
            <!-- <b-button variant="secondary" size="sm" style="display: inline-block; width: 30%;">Guide</b-button> -->
          </div>

          <b-card-title title-tag="h1" class="font-weight-bold mb-1">
            Welcome to CIS! 👋
          </b-card-title>
          <b-card-text class="mb-2">
            Please sign-in to your account
          </b-card-text>

          <!-- form -->
          <validation-observer ref="loginValidation">
            <b-form class="auth-login-form mt-2" @submit.prevent>
              <!-- email -->
              <b-form-group label="Username" label-for="login-username">
                <validation-provider
                  #default="{ errors }"
                  name="username"
                  rules="required|email"
                >
                  <b-form-input
                    id="login-username"
                    v-model="loginInfo.username"
                    :state="errors.length > 0 ? false : null"
                    name="login-username"
                    placeholder="john@example.com"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- forgot password -->
              <b-form-group>
                <div class="d-flex justify-content-between">
                  <label for="login-password">Password</label>
                  <b-link :to="{ name: 'forgot-password' }">
                    <small>Forgot Password?</small>
                  </b-link>
                </div>
                <validation-provider
                  #default="{ errors }"
                  name="password"
                  rules="required"
                >
                  <b-input-group
                    class="input-group-merge"
                    :class="{ 'is-invalid': errors.length > 0 }"
                  >
                    <b-form-input
                      id="login-password"
                      v-model="loginInfo.password"
                      :state="errors.length > 0 ? false : null"
                      class="form-control-merge"
                      :type="passwordFieldType"
                      name="login-password"
                      placeholder="············"
                    />
                    <b-input-group-append is-text>
                      <feather-icon
                        class="cursor-pointer"
                        :icon="
                          passwordFieldType === 'password'
                            ? 'EyeIcon'
                            : 'EyeOffIcon'
                        "
                        @click="togglePasswordVisibility"
                      />
                    </b-input-group-append>
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- checkbox -->
              <b-form-group>
                <b-form-checkbox
                  id="remember-me"
                  v-model="loginInfo.rememberMe"
                  name="checkbox-1"
                >
                  Remember Me
                </b-form-checkbox>
              </b-form-group>

              <!-- submit buttons -->
              <b-button
                type="submit"
                variant="primary"
                @click="validationForm"
                block
              >
                Sign in
              </b-button>
            </b-form>
          </validation-observer>
          <div class="container" style="margin-top: 40%;">
            <!-- <div class="row d-flex align-items-center">
              <div class="col-sm-9">
                <small>CONSUMER in SEARCH Ai 서비스에 대한 자세한 정보를 원하시면<br/>'Contact Us' 버튼을 클릭하세요</small>
              </div>
              <div class="col-sm-3">
                <b-button variant="secondary" size="sm">Contact Us</b-button>
              </div>
            </div> -->
          </div>
        </b-col>
      </b-col>
      <!-- /Login-->
    </b-row>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import {
  BRow,
  BCol,
  BLink,
  BFormGroup,
  BFormInput,
  BInputGroupAppend,
  BInputGroup,
  BFormCheckbox,
  BCardText,
  BCardTitle,
  BImg,
  BForm,
  BButton,
} from "bootstrap-vue";
import { required, email } from "@validations";
import { togglePasswordVisibility } from "@core/mixins/ui/forms";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { $themeConfig } from "@themeConfig";
import useJwt from "@/auth/jwt/useJwt";

import AuthenticationService from "@/services/authentication.service";

import CommonService from "@/services/common.service";

export default {
  name: "Login",
  components: {
    BRow,
    BCol,
    BLink,
    BFormGroup,
    BFormInput,
    BInputGroupAppend,
    BInputGroup,
    BFormCheckbox,
    BCardText,
    BCardTitle,
    BImg,
    BForm,
    BButton,
    ValidationProvider,
    ValidationObserver,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      loginInfo: {
        rememberMe: false,
        username: "",
        password: "",
      },
      passwordFieldType: "password",
      // validation rules import store from '@/store/index'
      required,
      email,
    };
  },
  methods: {
    openAbout(){
      window.open('https://consumerinsearch.com');
    },
    async test(){
      console.log('============ test =============')
      console.log('is it alright??')

      const response = await CommonService.test({});

      // console.log(response)



    },
    validationForm() {
      this.$refs.loginValidation.validate().then(async (success) => {
        if (success) {
          const response = await AuthenticationService.login(this.loginInfo);
          if (response.data.success) {
            this.$toast({
              component: ToastificationContent,
              position: "top-right",
              props: {
                title: "Welcome",
                icon: "CoffeeIcon",
                variant: "success",
                text: "You have successfully logged in. Now you can start to explore!",
              },
            });

            useJwt.setToken(response.data.data);

            const meResponse = await AuthenticationService.me(useJwt.getToken());
            useJwt.setLoginInfo(meResponse.data.data);

            window.location.href = "/";
          } else {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: response.data.message || "Unknown error",
                icon: "AlertCircleIcon",
                variant: "danger",
              },
            });
          }
        }
      });
    },
  },
  setup() {
    // App Name
    const { appName, appLogoImage } = $themeConfig.app;

    return {
      // App Name
      appName,
      appLogoImage,
    };
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/pages/page-auth.scss";
</style>
